module.exports = __webpack_public_path__ + "img/beer_id-86.c5e9d8db.png";